export const AccessLogsData = {
  logs: [
    {
      date: '2024/02/10:03:08:51',
      device: 'Chrome',
      host: 'test.server.com',
      ip: '66.22.345.10',
      request: 'GET',
      response_code: 404,
      response_size: 299,
      server_ip: '10.201.03.400',
    },
  ],
};
